import {PermissionType} from '@hconnect/apiclient'

import {Latest} from '../../common/types/latest'
import {PermissionParsed} from '../../permissions'
import {checkMultiplePermissions} from '../../permissions/helpers/checkMultiplePermissions'
import {checkPermissionAccessByDataScope} from '../../permissions/helpers/checkPermissionAccessByDataScope'

export const getFieldIsDisabled = (
  requiredPermissions: PermissionType[],
  latestData: Latest | undefined,
  userPermissions: PermissionParsed[],
  plantCode: string
): boolean => {
  if (requiredPermissions && requiredPermissions.length && latestData && userPermissions) {
    const granted = checkMultiplePermissions({
      permissions: userPermissions,
      requiredPermissionTypes: requiredPermissions,
      testFn: (permission) =>
        checkPermissionAccessByDataScope(latestData.country, plantCode, permission.parsedDataScope)
    })
    return !granted
  }

  return false
}
